export const COLUMN_LABEL_NORMAL = 'col-xs-8 col-md-8 col-lg-8 col-xl-8 ';
export const COLUMN_LABEL_FULL_WIDTH = 'col-xs-4 col-md-4 col-lg-4 col-xl-4 ';
export const COLUMN_INPUT_NORMAL_NO_UNIT = 'col-xs-4 col-md-4 col-lg-4 col-xl-4 ';
export const COLUMN_INPUT_FULL_WIDTH_NO_UNIT = 'col-xs-8 col-md-8 col-lg-8 col-xl-8 ';
export const COLUMN_INPUT_NORMAL_UNIT = 'col-xs-3 col-md-3 col-lg-3 col-xl-3 ';
export const COLUMN_INPUT_FULL_WIDTH_UNIT = 'col-xs-7 col-md-7 col-lg-7 col-xl-7 ';
export const COLUMN_UNIT = 'col-xs-1 col-md-1 col-lg-1 col-xl-1 no-padding ';
export const COLUMN_FULL = 'col-xs-12 col-md-12 col-lg-12 col-xl-12 ';
export const COLUMN_1 = 'col-xs-1 col-md-1 col-lg-1 col-xl-1 ';
export const COLUMN_2 = 'col-xs-2 col-md-2 col-lg-2 col-xl-2 ';
export const COLUMN_3 = 'col-xs-3 col-md-3 col-lg-3 col-xl-3 ';
export const COLUMN_4 = 'col-xs-4 col-md-4 col-lg-4 col-xl-4 ';
export const COLUMN_5 = 'col-xs-5 col-md-5 col-lg-5 col-xl-5 ';
export const COLUMN_6 = 'col-xs-6 col-md-6 col-lg-6 col-xl-6 ';
export const COLUMN_7 = 'col-xs-7 col-md-7 col-lg-7 col-xl-7 ';
export const COLUMN_8 = 'col-xs-8 col-md-8 col-lg-8 col-xl-8 ';
export const COLUMN_9 = 'col-xs-9 col-md-9 col-lg-9 col-xl-9 ';
export const COLUMN_10 = 'col-xs-10 col-md-10 col-lg-10 col-xl-10 ';
export const COLUMN_11 = 'col-xs-11 col-md-11 col-lg-11 col-xl-11 ';
